"use strict";
'use es6';
/*
  Total units = (tier included units) + (additional units)
  We want total units to stay the same, so we need to account for
  the difference between included units when switching plans
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateAdditionalUnitsForTierSwitch = calculateAdditionalUnitsForTierSwitch;
exports.getMerchSpecificSteppingFunction = exports.createSteppingFunction = void 0;

function calculateAdditionalUnitsForTierSwitch(oldUnits, oldProduct, newProduct) {
  if (oldProduct.id === newProduct.id) return oldUnits;
  var includedUnitsDifference = oldProduct.includedAdditionalUnits - newProduct.includedAdditionalUnits;
  var newMarketingUnits = oldUnits + includedUnitsDifference;
  var maxMarketingUnits = newProduct.maxAdditionalUnits - newProduct.includedAdditionalUnits;
  return Math.max(0, Math.min(maxMarketingUnits, newMarketingUnits));
}

var createSteppingFunction = function createSteppingFunction(min, max, step) {
  return function (input) {
    return Math.min(Math.round((Math.max(input, min) - min) / step) * step + min, max - (max - min) % step);
  };
};

exports.createSteppingFunction = createSteppingFunction;

var getMerchSpecificSteppingFunction = function getMerchSpecificSteppingFunction(merchandiseMap, baseMerchandiseId) {
  var _merchandiseMap$baseM = merchandiseMap[baseMerchandiseId],
      maxAdditionalUnits = _merchandiseMap$baseM.maxAdditionalUnits,
      additionalUnitMerchId = _merchandiseMap$baseM.additionalUnitMerchId;
  var quantityMultiplier = merchandiseMap[additionalUnitMerchId].quantityMultiplier;
  return createSteppingFunction(0, maxAdditionalUnits - maxAdditionalUnits % quantityMultiplier, quantityMultiplier);
};

exports.getMerchSpecificSteppingFunction = getMerchSpecificSteppingFunction;


//////////////////
// WEBPACK FOOTER
// ./js/utils/merchandiseUtils.js
// module id = 329
// module chunks = 5 6 7